import { render, staticRenderFns } from "./JudicialProcessesPage.vue?vue&type=template&id=235c18d2"
import script from "./JudicialProcessesPage.vue?vue&type=script&lang=js"
export * from "./JudicialProcessesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports